module.exports = __webpack_public_path__ + "static/media/whaticon.bb0595aa.svg";